import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Settings, UsersRound, KeyRound, LogOut, Menu } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/atm-seguros", label: "Panel", icon: LayoutDashboard, end: true },
    { to: "/atm-seguros/clientes", label: "Clientes", icon: Users },
    ...(user?.role === "admin" ? [
      { to: "/atm-seguros/config", label: "Configuracion", icon: Settings },
      { to: "/atm-seguros/usuarios", label: "Usuarios", icon: UsersRound },
    ] : []),
    { to: "/atm-seguros/cuenta", label: "Mi cuenta", icon: KeyRound },
  ];

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition ${isActive ? "bg-emerald-600 text-white" : "text-slate-600 hover:bg-slate-100"}`;

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex" data-testid="admin-layout">
      <aside className={`fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-slate-200 transform transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="p-5 border-b border-slate-200 flex items-center gap-2.5">
          <img src="/assets/logo-spm.png" alt="Seguros Para Moto" className="h-10 w-auto" />
        </div>
        <nav className="p-3 space-y-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={linkCls} data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`} onClick={() => setOpen(false)}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-3 border-t border-slate-200">
          <div className="px-3 py-2 text-xs text-slate-500">{user?.email}<span className="block text-slate-400 capitalize">{user?.role}</span></div>
          <button data-testid="logout-button" onClick={() => { logout(); navigate("/atm-seguros/login"); }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 w-full transition">
            <LogOut className="w-4 h-4" /> Salir
          </button>
        </div>
      </aside>
      {open && <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setOpen(false)} />}
      <div className="flex-1 min-w-0">
        <div className="lg:hidden bg-white border-b border-slate-200 p-3 flex items-center gap-3 sticky top-0 z-30">
          <button data-testid="menu-button" onClick={() => setOpen(true)} className="p-2 rounded-lg hover:bg-slate-100"><Menu className="w-5 h-5" /></button>
          <span className="font-heading font-bold text-slate-900">Seguros Para Moto</span>
        </div>
        <main className="p-4 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
